export default __webpack_public_path__ + "static/media/coinzix_logo_green_white.7f099a7c.png";